"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var TextLink_1 = require("../TextLink/TextLink");
var InputLabel_style_1 = __importDefault(require("./InputLabel.style"));
/**
 * InputLabel atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-inputlabel--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/InputLabel Source}
 */
var InputLabel = function (_a) {
    var className = _a.className, label = _a.label, link = _a.link, _b = _a.bottomMargin, bottomMargin = _b === void 0 ? 'default' : _b, additionalInfo = _a.additionalInfo, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var classes = (0, InputLabel_style_1.default)();
    var marginClass = (function () {
        switch (bottomMargin) {
            case 'large':
                return classes.largeMargin;
            case 'default':
                return classes.defaultMargin;
            case 'medium':
                return classes.mediumMargin;
            default:
                (0, objectUtilities_1.exhaustivenessCheck)(bottomMargin);
                return undefined;
        }
    })();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(className, classes.label, marginClass) }, { children: [renderLabel(), additionalInfo] })));
    function renderLabel() {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1.default)('labelWrap', disabled && classes.disabled) }, { children: label })), link && ((0, jsx_runtime_1.jsx)(TextLink_1.TextLink, __assign({ className: classes.link, fontVariant: 'label1', url: link.url, bold: true }, { children: link.linkText })))] }));
    }
};
exports.InputLabel = InputLabel;
